module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lead-organization"
  }, [_c('div', {
    staticClass: "lead-organization__form"
  }, [_c('p', {
    staticClass: "lead-organization__text"
  }, [_vm._v("Essa etapa permite que você organize seus contatos e tenha mais agilidade para encontrá-los dentro da base. Além disso, você pode escolher se vai enviar essa lista para outro usuário.")]), (_vm.show_user_options) ? _c('div', {
    staticClass: "form-group lead-organization__responsable"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "lead_responsable"
    }
  }, [_vm._v("Quem será o responsável por esses leads?")]), _c('div', {
    attrs: {
      "id": "lead_responsable"
    }
  }, [_c('dropdown-select', {
    attrs: {
      "options": _vm.filtered_user_options,
      "selected": _vm.selected_user_option
    },
    on: {
      "input": _vm.updateUserId
    },
    model: {
      value: (_vm.selected_user_option),
      callback: function($$v) {
        _vm.selected_user_option = $$v
      },
      expression: "selected_user_option"
    }
  })], 1)]) : _vm._e(), _c('div', {
    staticClass: "form-group lead-organization__fluxo"
  }, [_c('strong', {
    staticClass: "text-gray-color"
  }, [_vm._v("Enviar contatos para um fluxo?")]), _c('div', {
    staticClass: "toggler-inline"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.sent_to_flow
    }
  }), _c('label', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.switchSendToFlow()
      }
    }
  }, [_vm._v(_vm._s(_vm.sent_to_flow ? "Sim" : "Não"))]), (_vm.sent_to_flow) ? _c('flows', {
    attrs: {
      "user_id": _vm.selected_user
    },
    on: {
      "flow-selected": _vm.selectFlow
    }
  }) : _vm._e()], 1)]), (_vm.remaining > 0) ? _c('div', {
    staticClass: "form-group lead-organization__group"
  }, [(_vm.multiple_groups) ? _c('strong', {
    staticClass: "text-gray-color"
  }, [_vm._v("Adicionar contatos restantes a um grupo?")]) : _c('strong', {
    staticClass: "text-gray-color"
  }, [_vm._v("Adicionar contatos a um grupo?")]), _c('div', {
    staticClass: "toggler-inline half-width"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.add_to_group
    }
  }), _c('label', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.switchAddToGroup()
      }
    }
  }, [_vm._v(_vm._s(_vm.add_to_group ? "Sim" : "Não"))]), (_vm.add_to_group) ? _c('groups', {
    attrs: {
      "user_id": _vm.selected_user
    },
    on: {
      "group-selected": _vm.selectGroup
    }
  }) : _vm._e()], 1)]) : _vm._e(), _c('div', {
    staticClass: "lead-organization__filters"
  }, [_c('div', [_c('label', [_vm._v("Inserir tags nos contatos?")]), _c('tag-filter', {
    attrs: {
      "id": "tags_filter",
      "filter_item_selected_ids": _vm.selected_tags,
      "default_label": 'Nenhuma tag'
    },
    on: {
      "item-selected-items": _vm.updateTags
    }
  })], 1), _c('div', [_c('label', [_vm._v("Tags selecionadas:")]), _vm._l((_vm.selected_tags), function(selectedTag) {
    return _c('tags', {
      key: selectedTag.id,
      attrs: {
        "deletable": true,
        "tag": selectedTag
      },
      on: {
        "remove-tag": _vm.removeTag
      }
    })
  })], 2)])]), (_vm.multiple_groups) ? _c('div', {
    staticClass: "groups"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "text-gray-color"
  }, [_vm._v("Confirme a criação de novos grupos e/ou a inserção de contatos em grupos existentes")]), _vm._l((_vm.groups), function(group, index) {
    return _c('div', {
      staticClass: "contact-list-item-checkbox-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toogleCheck(index)
        }
      }
    }, [(_vm.getShowCheckboxGroupConditions(group)) ? _c('input', {
      staticClass: "checkbox-inline",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": group.selected
      }
    }) : _vm._e(), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getGroupText(group))
      }
    })])
  }), (_vm.remaining > 0 && _vm.selected_group == null) ? _c('div', {
    staticClass: "no-checkbox-inline contact-list-item-checkbox-item"
  }, [_c('label', [(_vm.remaining > 1) ? _c('strong', [_vm._v("Os " + _vm._s(_vm.remaining) + " contatos restantes não serão adicionados a grupos.")]) : _c('strong', [_vm._v("O contato restante não será adicionado a um grupo.")])])]) : (_vm.selected_group && _vm.remaining > 0) ? _c('div', {
    staticClass: "no-checkbox-inline contact-list-item-checkbox-item"
  }, [_c('label', [_c('strong', [_vm._v("Inserir " + _vm._s(_vm.remaining) + " contatos ")]), _c('span', [_vm._v("no grupo ")]), _c('strong', [_vm._v(_vm._s(_vm.selected_group.name))])])]) : _c('div', {
    staticClass: "no-checkbox-inline contact-list-item-checkbox-item"
  }, [_vm._m(0)])], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("Não há contatos restantes na sua planilha.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5da52798!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/lead_organization.vue
// module id = 1142
// module chunks = 1